import { render } from "./VideoProfile.vue?vue&type=template&id=18d14594&scoped=true"
import script from "./VideoProfile.vue?vue&type=script&lang=js"
export * from "./VideoProfile.vue?vue&type=script&lang=js"

import "./VideoProfile.scss?vue&type=style&index=0&id=18d14594&lang=scss&scoped=true"

import exportComponent from "/home/viewchat/public_html/viewchat-web-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18d14594"]])

export default __exports__